import { Injectable } from '@angular/core';
import { COMMON_PASSWORDS } from '../constant/common-words';

@Injectable({
  providedIn: 'root',
})
export class CommonPasswordService {
  private commonPasswordsArray: string[];

  constructor() {
    this.commonPasswordsArray = COMMON_PASSWORDS.split('\n');
  }

  public isCommonPassword(value: string): boolean {
    return this.commonPasswordsArray.indexOf(value) > -1;
  }
}
